// Module-level access-token store for the admin app. See Phase 2
// auth-hardening: the token is in-memory only; the refresh cookie owns
// long-lived auth.

let accessToken: string | null = null;
type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  for (const fn of listeners) fn(token);
}

export function clearAccessToken(): void {
  setAccessToken(null);
}

export function subscribeAccessToken(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
